import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, ActivityIcon, StethoscopeIcon, PillIcon } from 'lucide-react';
type Specialty = 'cardiologist' | 'nephrologist' | 'gp' | 'endocrinologist';
interface HeroSlideProps {
  onSelect: (specialty: Specialty) => void;
}
const specialties = [{
  id: 'cardiologist' as Specialty,
  label: 'Cardiologist',
  icon: HeartPulseIcon,
  bg: 'bg-rose-50',
  text: 'text-rose-600',
  hover: 'hover:ring-rose-300'
}, {
  id: 'nephrologist' as Specialty,
  label: 'Nephrologist',
  icon: ActivityIcon,
  bg: 'bg-teal-50',
  text: 'text-teal-600',
  hover: 'hover:ring-teal-300'
}, {
  id: 'gp' as Specialty,
  label: 'GP',
  icon: StethoscopeIcon,
  bg: 'bg-indigo-50',
  text: 'text-indigo-600',
  hover: 'hover:ring-indigo-300'
}, {
  id: 'endocrinologist' as Specialty,
  label: 'Endocrinologist',
  icon: PillIcon,
  bg: 'bg-amber-50',
  text: 'text-amber-600',
  hover: 'hover:ring-amber-300'
}];
export function HeroSlide({
  onSelect
}: HeroSlideProps) {
  return <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAF8] px-6 py-12" data-id="element-96">
      <div className="max-w-3xl w-full space-y-12" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-98">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1C1917] leading-[1.15] tracking-tight" data-id="element-99">
            Where do specialists disagree — and where do you stand?
          </h1>
          <p className="text-lg text-[#57534E] max-w-xl mx-auto leading-relaxed" data-id="element-100">
            Compare decisions, spot the biggest gaps, and see why they exist.
            Select your specialty to begin.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-101">
          {specialties.map((s, index) => {
          const Icon = s.icon;
          return <motion.button key={s.id} initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.1 + 0.05 * index
          }} whileHover={{
            y: -4
          }} whileTap={{
            scale: 0.97
          }} onClick={() => onSelect(s.id)} className={`flex flex-col items-center gap-4 p-6 bg-white rounded-2xl shadow-sm border border-neutral-100 ring-2 ring-transparent ${s.hover} transition-all cursor-pointer group`} data-id="element-102">
                <div className={`w-16 h-16 rounded-xl ${s.bg} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-103">
                  <Icon className={`w-8 h-8 ${s.text}`} data-id="element-104" />
                </div>
                <span className="text-base font-bold text-[#1C1917]" data-id="element-105">
                  {s.label}
                </span>
              </motion.button>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="text-xs text-neutral-400 text-center pt-8" data-id="element-106">
          Based on internal segmentation analysis
        </motion.p>
      </div>
    </div>;
}